export const NAVPOINTS: { [key: string]: string } = {
    'type': 'sport',
    'football': '16',
    'footballsport': 'football',
    'tennissport': 'tennis',
    'horseracing': 'horse-racing',
    'tennis': '34',
    'horse-racing': '21',
};

//Add sport ids where you want to extend CLS in SLP
export const SPORT_CATEGORIES = ['16', '34', '21'];

// Add sport names where banners are not enabled in most scenario's
export const NO_BANNER_SPORTS = ['tennis'];
